module.exports = __webpack_public_path__ + "img/video_bg.5eadfa79.jpg";